/** Format a $CARDS token amount for display (max 2 decimals, thousands separators). */
export function formatCards(amount: number | null | undefined): string {
  if (amount === null || amount === undefined) return "—";
  return amount.toLocaleString(undefined, { maximumFractionDigits: 2 });
}

/** $CARDS received per 1,000 points gained (null when not computable). */
export function cardsPerThousandPoints(
  cards: number | null | undefined,
  points: number | null | undefined
): number | null {
  if (cards === null || cards === undefined) return null;
  if (!points || points <= 0) return null;
  return cards / (points / 1000);
}

export function formatDateRange(fromIso: string, toIso: string): string {
  const opts: Intl.DateTimeFormatOptions = { month: "short", year: "numeric", timeZone: "UTC" };
  const from = new Date(fromIso);
  // periodTo is an exclusive bound (first day of the next quarter) - show the last month
  const toInclusive = new Date(new Date(toIso).getTime() - 1);
  return `${from.toLocaleDateString(undefined, opts)} – ${toInclusive.toLocaleDateString(undefined, opts)}`;
}

/** "$1,234" (no decimals), "—" when unknown. */
export function formatUsd(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  return `$${Math.round(value).toLocaleString()}`;
}

/** "+$1,234" / "−$1,234" for profit and loss. */
export function formatSignedUsd(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  const rounded = Math.round(value);
  if (rounded === 0) return "$0";
  return `${rounded > 0 ? "+" : "−"}$${Math.abs(rounded).toLocaleString()}`;
}

/** "+12.3%" / "−4.5%", from a fraction (0.123). */
export function formatSignedPct(fraction: number | null | undefined): string {
  if (fraction === null || fraction === undefined || !Number.isFinite(fraction)) return "—";
  const pct = fraction * 100;
  const sign = pct > 0 ? "+" : pct < 0 ? "−" : "";
  return `${sign}${Math.abs(pct).toFixed(Math.abs(pct) >= 100 ? 0 : 1)}%`;
}

/** "42.5%" from a fraction. */
export function formatPct(fraction: number | null | undefined): string {
  if (fraction === null || fraction === undefined || !Number.isFinite(fraction)) return "—";
  return `${(fraction * 100).toFixed(1)}%`;
}
